
export class Utils {
    static getLanguageName(langCode: string) {
        switch (langCode) {
            case "it":
                return "Italian";
            case "en":
                return "English";
            case "de":
                return "German";
            case "es":
                return "Spanish";
            case "fr":
                return "French";
            case "hu":
                return "Hungarian";
            case "pt":
                return "Portoguese";
            case "pl":
                return "Polish"
            case "ro":
                return "Romanian";
            case "ru":
                return "Russian";
            case "nl":
                return "Dutch";
            case "cs":
                return "Czech";
            case "sl":
                return "Slovenian";
            case "sk":
                return "Slovak";
            case "ar":
                return "Arabic";
            case "sr":
                return "Serbian";
            default:
                return "";
        }
    }

    static getCompletionColor(percentage: number) {
        if (percentage < 50) {
            return 'red';
        }

        if (percentage >= 50 && percentage <= 99) {
            return 'yellow';
        }

        if (percentage == 100) {
            return 'green';
        }
    }

    static iconPlatformClass(staticClass: string, platform: string) {
        let mountedClass: string[] = [staticClass];
        let iconName = '';

        switch (platform) {
            case 'Android':
                iconName = 'android';
                break;
            case 'iOS':
                iconName = 'apple';
                break;
            case 'Android/iOS':
            case 'Web':
                iconName = 'globe';
                break;
            default:
                break;
        }

        mountedClass.push(`icon-${iconName}-16`);

        return mountedClass;
    }
}

export const promiseTimeout = function (ms: number, promise: Promise<any>) {
    let timeout = new Promise((resolve, reject) => {
        let id = setTimeout(() => {
            clearTimeout(id);
            reject('Timed out in ' + ms + 'ms.')
        }, ms)
    })
    return Promise.race([
        promise,
        timeout
    ])
}